import { Theme } from "@mui/material";

import { LabelType } from "@/hooks/useConfig";
import { BCPLayer, Layer } from "@/Utils/hierarchy";

export const getDisplayLabel = (layer: BCPLayer, label: LabelType): string => {
  switch (layer) {
    case Layer.Brand:
      return label.brand;
    case Layer.Category:
      return label.category;
    case Layer.Product:
      return label.product;
  }
};

export const getLayerColor = (layer: BCPLayer, type: "spend" | "revenue", theme: Theme): string => {
  switch (layer) {
    case Layer.Brand:
      return type === "spend"
        ? theme.palette.spendRevenueGraph.spend.brand
        : theme.palette.spendRevenueGraph.revenue.brand;
    case Layer.Category:
      return type === "spend"
        ? theme.palette.spendRevenueGraph.spend.category
        : theme.palette.spendRevenueGraph.revenue.category;
    case Layer.Product:
      return type === "spend"
        ? theme.palette.spendRevenueGraph.spend.product
        : theme.palette.spendRevenueGraph.revenue.product;
  }
};
